export default "__VITE_ASSET__Djfv7M8H__"